export default __webpack_public_path__ + "static/media/JiraServiceManagement.07a2163f.svg";